import { ECardType } from '__generated__/globalTypes';
import { AddCard } from 'components/detail/edit/EditDetail/EditDetailCards/AddCard';
import { EditGIFCard } from 'components/detail/edit/EditDetail/EditDetailCards/cards/EditGIFCard';
import { EditImageCard } from 'components/detail/edit/EditDetail/EditDetailCards/cards/EditImageCard';
import { EditLinkCard } from 'components/detail/edit/EditDetail/EditDetailCards/cards/EditLinkCard';
import { EditLinkedStoriesCard } from 'components/detail/edit/EditDetail/EditDetailCards/cards/EditLinkedStoriesCard';
import { EditSocialsCard } from 'components/detail/edit/EditDetail/EditDetailCards/cards/EditSocialsCard';
import { EditTextCard } from 'components/detail/edit/EditDetail/EditDetailCards/cards/EditTextCard';
import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import { SidebarSectionHeader } from 'elements/minute/sidebar/sidebarSection/SidebarSection/SidebarSectionHeader';
import { EColors } from 'libs/styles/styling';
import React, { useContext } from 'react';
import { CtxApp } from 'session/ctxApp';
import { CtxDetail } from 'session/ctxDetail';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EditDetailCards = (props: Props): JSX.Element => {
    const ctxDetail = useContext(CtxDetail);
    const ctxApp = useContext(CtxApp);

    const cards = ctxDetail.updateDetailInput.cards.map((card, index) => {
        return (
            <React.Fragment key={card.cardId}>
                {card.type === ECardType.FACEBOOK && (
                    <EditSocialsCard
                        position={index}
                        type={{
                            iconName: 'facebook',
                            title: 'Facebook',
                            subTitle: Localization.POST_URL,
                            fieldName: 'facebook',
                            fieldSubName: 'postId'
                        }}
                    />
                )}
                {card.type === ECardType.LINKEDSTORIES && (
                    <EditLinkedStoriesCard position={index} />
                )}
                {card.type === ECardType.GIF && <EditGIFCard position={index} />}
                {card.type === ECardType.IMAGE && <EditImageCard position={index} />}
                {card.type === ECardType.INSTAGRAM && (
                    <EditSocialsCard
                        position={index}
                        type={{
                            iconName: 'instagram',
                            title: 'Instagram',
                            subTitle: Localization.POST_URL,
                            fieldName: 'instagram',
                            fieldSubName: 'postId'
                        }}
                    />
                )}
                {card.type === ECardType.LINK && <EditLinkCard position={index} />}
                {card.type === ECardType.TEXT && <EditTextCard position={index} />}
                {card.type === ECardType.TWITTER && (
                    <EditSocialsCard
                        position={index}
                        type={{
                            iconName: 'twitter',
                            title: 'Twitter',
                            subTitle: Localization.POST_ID,
                            fieldName: 'twitter',
                            fieldSubName: 'postId'
                        }}
                    />
                )}
                {card.type === ECardType.VIDEO && (
                    <EditSocialsCard
                        position={index}
                        type={{
                            iconName: 'youtube',
                            title: 'Youtube',
                            subTitle: Localization.VIDEO_URL,
                            fieldName: 'video',
                            fieldSubName: 'videoId'
                        }}
                    />
                )}
                {ctxApp.minuteEditor && <S_AddCard position={index + 1} />}
                {!ctxApp.minuteEditor && (
                    <S_SetEditorContent
                        $disableBottomBorder={
                            index === ctxDetail.updateDetailInput.cards.length - 1
                        }
                    >
                        <AddCard position={index + 1} />
                    </S_SetEditorContent>
                )}
            </React.Fragment>
        );
    });

    return (
        <S_EditDetailCards2 className={props.className}>
            <SidebarSectionHeader
                icon={{
                    iconName: 'shapes'
                }}
                title={Localization.CONTENT}
            />
            {ctxDetail.updateDetailInput?.cards?.length === 0 && (
                <S_Mid>
                    <S_Message type="info">{Localization.CONTENT_DESC}</S_Message>
                </S_Mid>
            )}
            <S_AddCard position={0} />
            <S_Cards>{cards}</S_Cards>
        </S_EditDetailCards2>
    );
};

const S_Mid = styled.div`
    padding: 15px 15px 0 15px;
`;

const S_Message = styled(Message)`
    margin: 0 0 0px 0;
`;

const S_EditDetailCards2 = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
`;

const S_AddCard = styled(AddCard)`
    margin: 15px 0 15px 0;
`;

const S_Cards = styled.div`
    padding: 0 15px;
`;

const S_SetEditorContent = styled.div<{ $disableBottomBorder: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 15px 20px 15px 20px;
    box-sizing: border-box;
    border-bottom: ${(props) =>
        props.$disableBottomBorder ? 'none' : `1px solid ${EColors.BLACK3}`};
`;
